<template>
  <section>
    <v-dialog
      :value="isOpenDialog"
      @click:outside="closeDialog"
      max-width="550px"
    >
      <v-card :loading="isLoading">
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              Reciclar
            </v-card-title>
          </v-img>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-select
                :items="statusList"
                v-model="payload.status_registers"
                label="Estados a reciclar"
                item-text="name"
                item-value="id"
                prepend-icon=""
                prepend-inner-icon="mdi-list-status"
                filled
                multiple
                rounded
                class="rounded-small"
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-select
                :items="statusList"
                v-model="payload.status_register_id_new"
                label="Nuevo estado"
                item-text="name"
                item-value="id"
                prepend-inner-icon="mdi-plus"
                filled
                rounded
                class="rounded-small"
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="12">
              <p class="text-caption v-messages">
                Si no selecciona ninguna opcion, se reciclaran todos al estado
                por defecto
              </p>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="danger" @click="closeDialog" text rounded>
            Cancelar
          </v-btn>
          <v-btn
            :loading="isLoading"
            color="success"
            class="px-5"
            @click="openConfirm"
            large
            rounded
          >
            Reciclar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Confirm -->
    <v-dialog
      :value="isOpenConfirm"
      @click:outside="closeConfirm"
      max-width="600px"
    >
      <v-card>
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              Confirmar reciclar
            </v-card-title>
          </v-img>
        </v-card-title>
        <v-card-text>
          Esta seguro que desea reciclar esta campaña?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="danger" @click="closeConfirm" text rounded>
            Cancelar
          </v-btn>
          <v-btn color="success" class="px-5" @click="submitForm" large rounded>
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card></v-dialog
    >
  </section>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
export default {
  props: {
    isOpenDialog: { type: Boolean, required: true },
    campaignId: { type: Number, required: true },
    statusList: { type: Array, required: true }
  },
  data() {
    return {
      isLoading: false,
      isOpenConfirm: false,
      payload: {
        campaign_id: Number(this.campaignId),
        status_registers: [],
        status_register_id_new: null
      }
    };
  },
  methods: {
    closeDialog() {
      this.$emit("dialog:close");
    },
    async submitForm() {
      this.closeConfirm();
      this.isLoading = true;
      try {
        await PbxHttpClient.post(`/campaign/reset_register`, this.payload);
        this.$snotify.success("Campaña reciclada con éxito.", "¡Hecho!");
        this.closeDialog();
      } catch (error) {
        // console.log(error);
        this.$snotify.error("Hubo un error reciclando la campaña.", "¡Error!");
      }
      this.isLoading = false;
    },

    openConfirm() {
      this.isOpenConfirm = true;
    },
    closeConfirm() {
      this.isOpenConfirm = false;
    }
  }
};
</script>

<style></style>
